'use client';
import { jsx } from 'react/jsx-runtime';
import { Provider } from './../../../external/@radix-ui/react-tooltip/dist/index.js';

const TooltipProvider = ({ children, }) => {
    return jsx(Provider, { children: children });
};

export { TooltipProvider };
//# sourceMappingURL=provider.js.map
